var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"header",class:{ 'scoll-fixed': _vm.isfixed }},[_c('section',[_c('div',{staticClass:"input-text",on:{"click":_vm.goSearch}},[_vm._v(" 商品名称 "),_c('span',{staticClass:"iconfont icon-sousuo"})])])])}
var staticRenderFns = []

export { render, staticRenderFns }